export default {
  reg: {
    letter: 'Only English letters and spaces are allowed'
  }
}
